import { LocalStorageKeys, URL } from 'utils/constants';

export const onLogout = () => {
  localStorage.removeItem(LocalStorageKeys.access_token);
  localStorage.removeItem(LocalStorageKeys.refresh_token);
  localStorage.removeItem(LocalStorageKeys.vendor);
  window.location.href = URL.LOGIN;
};
